var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 51C39.8071 51 51 39.8071 51 26C51 12.1929 39.8071 1 26 1C12.1929 1 1 12.1929 1 26C1 39.8071 12.1929 51 26 51Z",
    fill: "#FF4F00",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9996 33.7226C24.7185 33.7226 23.6787 32.7212 23.6787 31.4874V13.6058C23.6787 12.372 24.7185 11.3706 25.9996 11.3706C27.2808 11.3706 28.3206 12.372 28.3206 13.6058V31.4874C28.3206 32.7212 27.2808 33.7226 25.9996 33.7226Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9996 40.629C25.3962 40.629 24.7928 40.3831 24.3518 39.9808C23.934 39.5561 23.6787 38.9749 23.6787 38.3938C23.6787 37.8126 23.934 37.2315 24.3518 36.8068C25.2337 35.9798 26.7656 35.9798 27.6475 36.8068C28.0653 37.2315 28.3206 37.8126 28.3206 38.3938C28.3206 38.9749 28.0653 39.5561 27.6475 39.9808C27.2065 40.3831 26.6263 40.629 25.9996 40.629V40.629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.e9bc479d363a7122498da7730c108024.svg";
export { ForwardRef as ReactComponent };